export default {
	install: function (Vue, options) {

		const language = 'language' in options?options.language:'pt-BR';
		let dict = {}
		try{
			dict = require(`./${language}.json`);
		} catch(e){
		}

		Vue.mixin({
			methods:{
				_lang(text,context) {
					context = context || 'general';
					if(context in dict && text in dict[context]) return dict[context][text];
					return text;
				},
			}
		})
	}
}
